module.exports = __webpack_public_path__ + "static/media/Bone In Pork.3c14c3fa.jpg";